<template lang="pug">
substrate.what-is-this-modal(v-if="active" @close="active = false")
  img.substrate__popup-change-pass__image(:src="imgSrc" alt='card')
  p.m-t-40(v-if="subText") {{ subText }}
</template>

<script>
import ConfigMixin from '../_mixins/config'

export default {
  name: 'what-is-modal',

  mixins: [
    ConfigMixin,
  ],

  props: {
    imgSrc: {
      type: String,
      required: true,
    },
    subText: {
      type: String,
      default: null,
    },
  },

  data: () => ({
    active: false,
  }),

  methods: {
    show() {
      this.active = true
    }
  }
}
</script>
